<form [formGroup]="featuresEquipmentForm">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2
      dsContent
      [contentPath]="'policy.newVehicleFeaturesAndEquipmentsHeader'"
      class="bold-header"
    ></h2>
    <div class="add-vehicle-title">
      <div class="row vehicle">
        <div class="flex self-center pad-10">
          <div class="self-center pad-right-30" aria-hidden="true">
            <span class="icon-auto"></span>
          </div>
          <div class="self-center">
            <div class="risk-info">
              <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
              <div class="heading">
                {{ vehicleRiskDescription$ | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if ((vehicleFeatureDescriptionList$ | async)?.length > 1) {
      <div>
        <h3 dsContent [contentPath]="'policy.newVehicleFeaturesAndEquipmentsSubHeader'"></h3>
        <p
          class="margin-bottom-10"
          dsContent
          [contentPath]="'policy.newVehicleFeaturesAndEquipmentsDiscountInfo'"
          data-cy="vehicleFeatureEquipmentDiscountText"
        ></p>
      </div>
    }
    @if (
      ((isStateEligibleForAntiTheftFeature$ | async) &&
        (vehicleFeatureDescriptionList$ | async)?.length < 5) ||
      ((isStateEligibleForAntiTheftFeature$ | async) === false &&
        (vehicleFeatureDescriptionList$ | async)?.length < 4)
    ) {
      <div>
        @if (!(vehicleFeatureDescriptionList$ | async)?.length) {
          <h3
            dsContent
            [contentPath]="'policy.newVehicleFeaturesAndEquipmentsSubHeaderSomeOrNoEquipmentFound'"
            data-cy="vehicleFeatureEquipmentNotFoundText"
          ></h3>
        }
      </div>
    }

    <div class="margin-top-20 margin-bottom-20">
      <ds-equipment-list
        [equipmentList]="vehicleFeatureDescriptionList$ | async"
        [isPartner]="isPartner$ | async"
        [userState]="userState$ | async"
      ></ds-equipment-list>
      @if (
        (equipmentList$ | async)?.length > 0 ||
        (equipmentChecklist$ | async)?.length > 0 ||
        featuresCategoryForm
      ) {
        <h3
          class="margin-bottom-20"
          dsContent
          [contentPath]="'policy.newVehicleFeatureEquipmentQuestion'"
        ></h3>
        <p
          class="margin-bottom-10"
          dsContent
          [contentPath]="'policy.newVehicleFeaturesAndEquipmentsSomeOrNoEquipmentFoundInfo'"
        ></p>
        <ds-equipment-selection-list
          [equipmentList]="equipmentList$ | async"
          [equipmentChecklist]="equipmentChecklist$ | async"
          [form]="featuresEquipmentForm"
          [categoryform]="featuresCategoryForm"
          [state]="userState$ | async"
          (checklistUpdateEvent)="handleCheckBoxInteraction($event)"
          (checklistCategoryUpdateEvent)="handleCheckBoxCategoryInteraction($event)"
        ></ds-equipment-selection-list>
      }
    </div>
  </div>
  @if (!!featuresEquipmentForm) {
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <call-to-action
        [displayBackButton]="true"
        [tertiaryButtonName]="'Cancel'"
        [disabled]="featuresEquipmentForm.invalid"
        [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
        (primaryEvent)="submitVehicleFeaturesInfo()"
        (tertiaryEvent)="cancelEvent.emit(true)"
        (backEvent)="goBackOneStep()"
      ></call-to-action>
    </div>
  }
</form>
